// extracted by mini-css-extract-plugin
export var actionText = "_sk-4";
export var container = "_sk-0";
export var leftSection = "_sk-1";
export var rightSection = "_sk-2";
export var settingsButton = "_sk-6";
export var settingsIcon = "_sk-7";
export var shortcut = "_sk-5";
export var shortcutGroup = "_sk-3";